import { useState } from 'react';
import { StateType } from '../components/DraggableContainer';

interface UseDraggableStateResponse {
  state: StateType;
  storeState: (state: StateType) => void;
}

const retrieveStoredState = (initialState: StateType): StateType => {
  const storedValue = localStorage.getItem(`DRAGGABLE_STATE`);

  if (!storedValue) return initialState;

  return storedValue as StateType;
};

const setStoredState = (state: StateType) => {
  localStorage.setItem(`DRAGGABLE_STATE`, state);
};

export const useDraggableState = (initialState: StateType): UseDraggableStateResponse => {
  const [state, setState] = useState<StateType>(retrieveStoredState(initialState));

  const storeState = (state: StateType) => {
    setStoredState(state);
    setState(state);
  };

  return {
    state,
    storeState,
  };
};
